import {getViewportWidth, getViewportHeight, getDocumentHeight} from '../../common/utils/size';
import PageComponent from '../../common/component/page-component';


class IntersectableComponent extends PageComponent {

	constructor({
		root,
		element,
		intersectingAttribute = 'section',
		intersectingColorSchemeAttribute = 'sectionColorScheme',
		threshold = 0
	}) {
		super({root: root, element: element});
		this.intersectingAttribute = intersectingAttribute;
		this.intersectingColorSchemeAttribute = intersectingColorSchemeAttribute;
		this.defaults.threshold = threshold;
		this.currentMargins = null;
		this.inside = new Set();
		// this.marker = document.createElement('div');
		// this.root.appendChild(this.marker);
		// this.marker.style.position = 'fixed';
		// this.marker.style.zIndex = 1000;
		// this.marker.style.border = '1px solid red';
	}


	injectIntersectionObservers(intersectionObservers) {
		this.intersectionObservers = intersectionObservers;
	}


	prepare() {
		this.threshold = this.dataAttr().get('threshold');
		this.observed = this.root.querySelectorAll(this.dataSelector(this.intersectingAttribute));
		this.updateObserver();
		this.listeners.resize = this.events.on(window, 'window:resize', this.onResize.bind(this));
	}


	clear() {
		this.intersectionObservers.destroyObserver(this);
		this.inside.clear();
		this.observed = null;
	}


	onResize(event) {
		this.updateObserver();
	}


	onIntersect(entries) {
		/*
			intersection observer is not very reliable in the order of calls
			a sequence that can happen is:
			A > IN
			B > IN
			B > OUT
			that would leave the area empty,
			which is not possible in our scenario because they are contiguous
			so we need to create a list of intersecting elements and eventually recover
			the last one that is still inside even if not reported as intersecting when
			the previous is leaving
		*/
		let intersectingTarget = null;
		for (const entry of entries) {
			if (entry.isIntersecting) {
				intersectingTarget = entry.target;
				this.inside.add(entry.target);
				// console.log('IN', this.dataAttr(entry.target).get(this.intersectingAttribute), entry);
			} else {
				this.inside.delete(entry.target);
				// console.log('OUT', this.dataAttr(entry.target).get(this.intersectingAttribute), entry);
			}
		}
		if (intersectingTarget && this.inside.size === 1) {
			// triggers when there is only one inside and it is reported right now
			// console.log('SET', this.dataAttr(intersectingTarget).get(this.intersectingAttribute));
			this.toggleIntersection(intersectingTarget);
		} else if (this.inside.size === 1) {
			// someone left, without new entries, we recover the previous one still inside
			for (const item of this.inside.values()) {
				// console.log('RESTORE', this.dataAttr(item).get(this.intersectingAttribute));
				this.toggleIntersection(item);
				break;
			}
		}
	}


	updateObserver() {
		const newMargins = this.formatMargins(this.calculateMargins());
		if (newMargins !== this.currentMargins) {
			// const margin = this.calculateMargins();
			// this.marker.style.top = -margin.top + 'px';
			// this.marker.style.right = -margin.right + 'px';
			// this.marker.style.bottom = -margin.bottom + 'px';
			// this.marker.style.left = -margin.left + 'px';
			this.currentMargins = newMargins;
			this.intersectionObservers.destroyObserver(this);
			this.intersectionObservers.initObserver(this, this.threshold, this.onIntersect.bind(this), newMargins);
			this.intersectionObservers.observe(this, this.observed);
		}
	}


	/**
	 * Gives an intersection area with full width and 1px height in the middle of the element
	 */
	calculateMargins() {
		const vw = getViewportWidth();
		const vh = getViewportHeight();
		const rect = this.element.getBoundingClientRect();
		const halfHeight = rect.top + Math.floor(rect.height / 2);
		return {
			top: -halfHeight,
			right: 0,
			bottom: -(vh - halfHeight - 1),
			left: 0
		};
	}


	formatMargins(margins) {
		return `${margins.top}px ${margins.right}px ${margins.bottom}px ${margins.left}px`;
	}




	// to be overriden
	toggleIntersection(intersectingElement) {
	}

}

export default IntersectableComponent;
